import { Pipe, PipeTransform } from '@angular/core';
import { isUndefined } from '../utils/utils';

@Pipe({
  name: 'stringular'
})
export class StringularPipe implements PipeTransform {
  transform(template: string, ...args: string[]): string {
    return template.replace(/{(\d+)}/g, (match, number) => {
      return isUndefined(args[number]) ? match : args[number];
    });
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/string/stringular.pipe.ts